import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useEffect } from "react";
import httpService from "services/httpService";
import { useParams } from "react-router-dom";
import {
  toastrErrorAlert,
  toastrSuccessAlert,
} from "components/Common/AlertToastr";
import TextareaField from "components/form-control/Textarea";
import SelectConst from "components/form-control/SelectConst";
import { GET_QUESTION, GET_SCHEMAS, GET_SYSCFG } from "helpers/url_helper";
import { CommonButton } from "components/Common/ButtonCommon";
import Spacer from "../../../components/Common/Spacing";
import { ALPHABET } from "constants/dataPHL";
import styled from "styled-components";
import { message, Modal } from "antd";

const ANSWER_DEFAULT = ["A", "B", "C", "D"];

const { confirm } = Modal;

export default function DetailQuestion() {
  const [answer, setAnswer] = useState([]);
  const [answerTotal, setAnswerTotal] = useState([]);
  const [question, setQuestion] = useState({});
  const [category, setCategory] = useState([]);
  const [schemaQuestion, setSchemaQuestion] = useState({});
  const schema = yup.object({}).required();
  const [open, setOpen] = useState(false);

  const {
    handleSubmit,
    formState: { errors },
    ...rest
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
    shouldUnregister: true,
  });

  const { id } = useParams();
  const url = `${GET_QUESTION}/${id}`;

  useEffect(async () => {
    fetchSchema();
    fetchCategory();
  }, [id]);

  const fetchQuestion = async () => {
    const res = await httpService.get(url);
    setQuestion(res);
    rest.reset({ ...res, category: res.category?.objectId });
  };

  const fetchCategory = async () => {
    try {
      const getCategory = await httpService.get(
        `${GET_SYSCFG}?where={"Category": "questionCategory"}&order=-createdAt`
      );
      setCategory(getCategory.results);
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchSchema = async () => {
    try {
      const schemaSelected = await httpService.get(`${GET_SCHEMAS}/Question`);
      setSchemaQuestion(schemaSelected);
      const res = await httpService.get(url);
      setQuestion(res);

      Object.entries(schemaSelected?.fields).map(field => {
        if (ALPHABET.includes(field[0])) {
          setAnswerTotal(prev => [...prev, field[0]]);
        }
        if (
          (ALPHABET.includes(field[0]) &&
            res[field[0]] &&
            res[field[0]] !== undefined) ||
          ANSWER_DEFAULT.includes(field[0])
        ) {
          setAnswer(prev => [...prev, field[0]]);
          return field[0];
        }
      });

      rest.reset({
        ...res,
        category: res.category?.objectId,
      });
    } catch (error) {
      toastrErrorAlert(error);
    }
  };

  const handleShowConfirm = item => {
    setOpen(prev => !prev);
    confirm({
      title: "Bạn có chắc chắn muốn xoá đáp án này hay không?",
      onOk: async () => {
        if (rest.getValues("correctAnswer") === item) {
          message.error(
            "Vui lòng lưu 'Câu trả lời đúng' khác trước khi xoá!!!"
          );
          return;
        }
        const params = {
          where: {
            [item]: { $exists: true },
          },
          count: 1,
        };
        const response = await httpService.get(`${GET_QUESTION}`, {
          params,
        });

        const { count } = response;
        rest.unregister(item, {
          keepValue: false,
          keepIsValid: false,
        });

        if (count === 1) {
          try {
            const updateValues = {
              fields: {
                ...schemaQuestion.fields,
                [item]: { __op: "Delete" },
              },
            };
            await httpService.put(`${GET_SCHEMAS}/Question`, updateValues, {
              headers: {
                "X-Parse-Master-Key": "LASDK106JKHR87SDFJSDHF0DFHASFDF",
              },
            });
            const schemaSelected = await httpService.get(
              `${GET_SCHEMAS}/Question`
            );

            setSchemaQuestion(schemaSelected);
            setAnswer(prev => prev.filter(i => i !== item));
            setAnswerTotal(prev => prev.filter(i => i !== item));
            fetchQuestion();
            message.success("Xoá đáp án thành công!!!");
          } catch (error) {
            message.error("Xoá đáp án không thành công!!!");
          }
          return;
        }

        try {
          await httpService.put(url, {
            [item]: { __op: "Delete" },
          });

          setAnswer(prev => prev.filter(i => i !== item));
          setAnswerTotal(prev => prev.filter(i => i !== item));
          rest.setValue("correctAnswer", rest.getValues("correctAnswer"));
          message.success("Xoá đáp án thành công!!!");
        } catch (error) {
          message.error("Xoá đáp án không thành công!!!");
        }
      },
    });
  };

  const onSubmit = async value => {
    const { createdAt, updatedAt, objectId, ...question } = value;

    try {
      if (!Object.entries(question).every(value => value[1] !== "")) {
        message.error("Vui lòng nhập đáp án, đáp án không được để trống!!");
        return;
      }

      const questionMap = Object.entries(question).map(value => {
        if (value[1] === "") {
          return [value[0], { __op: "Delete" }];
        }
        if (value[0] === "category") {
          return [
            value[0],
            {
              objectId: value[1],
              className: "SysCfg",
              __type: "Pointer",
            },
          ];
        }
        return [value[0], value[1]];
      });

      const res = await httpService.put(url, Object.fromEntries(questionMap));
      if (res?.updatedAt) {
        toastrSuccessAlert("Cập nhật câu hỏi thành công!!");
        fetchQuestion();
      }

      return;
    } catch (error) {
      toastrErrorAlert("Cập nhật câu hỏi thất bại!!");
    }
  };

  const handleAddAnswer = async () => {
    let index = 0;
    for (const item of ALPHABET) {
      if (answer.includes(item) && answer.length <= answerTotal.length) {
        index++;
        continue;
      }
      if (!answer.includes(item) && answer.length <= answerTotal.length) {
        setAnswer(prev => [...prev, item]);
        if (!answerTotal.includes(item)) {
          setAnswerTotal(prev => [...prev, item]);
        }

        index++;
        break;
      }

      setAnswer(prev => [...prev, ALPHABET[answer.length]]);
      if (!answerTotal.includes(ALPHABET[answer.length])) {
        setAnswerTotal(prev => [...prev, ALPHABET[answer.length]]);
      }
      return;
    }
  };

  const handleCorrectAnswerSelect = async e => {
    try {
      await httpService.put(url, {
        correctAnswer: e.target.value,
      });
      fetchQuestion();
      return;
    } catch (error) {
      toastrErrorAlert("Cập nhật câu hỏi thất bại!!");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <form onSubmit={handleSubmit(onSubmit)}>
            <HeaderCreateItem title={`Chi tiết câu hỏi`}>
              <div className="d-flex align-items-center mb-2">
                <div className="flex-grow-1"></div>
                <Spacer size={12} />
                <CommonButton level={3} type="submit">
                  Lưu
                </CommonButton>
              </div>
            </HeaderCreateItem>
            <Row>
              <Col sm={12}>
                <TextareaField
                  label={"Nội dung câu hỏi"}
                  {...rest}
                  name="content"
                  rows={8}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <SelectConst
                  label="Câu trả lời đúng"
                  name="correctAnswer"
                  options={answer?.map(item => {
                    return {
                      text: item,
                      value: item,
                    };
                  })}
                  onChange={handleCorrectAnswerSelect}
                  {...rest}
                />
              </Col>
              <Col sm={4}>
                <SelectConst
                  label="Chủ đề"
                  name="category"
                  options={category?.map(item => {
                    return {
                      text: item.Name,
                      value: item?.objectId,
                    };
                  })}
                  {...rest}
                />
              </Col>
            </Row>
            <Row>
              {answer?.map((item, index) => (
                <Col sm={3} key={index + item} style={{ position: "relative" }}>
                  <TextareaField
                    label={`Câu trả lời ${item}${
                      item === question?.correctAnswer ? "(đúng)" : "(sai)"
                    }`}
                    {...rest}
                    name={item}
                    rows={8}
                    styleInput={{
                      border: `1px solid ${
                        item === question?.correctAnswer ? "#15c415" : "gray"
                      }`,
                    }}
                  />
                  {!ANSWER_DEFAULT.includes(item) && (
                    <IconCloseStyled
                      className="fas fa-times text-danger"
                      onClick={() => handleShowConfirm(item)}
                    />
                  )}
                </Col>
              ))}
              <Col sm={3}>
                <IconPlusStyled
                  className="bx bx-plus-circle"
                  onClick={handleAddAnswer}
                />
              </Col>
            </Row>
          </form>
        </Container>
      </div>
    </React.Fragment>
  );
}

const IconPlusStyled = styled.i`
  font-size: 2rem;
  color: orange;
  cursor: pointer;
  padding-top: 20px;
`;

const IconCloseStyled = styled.i`
  position: absolute;
  top: 20px;
  right: 12px;
  cursor: pointer;
`;
